import { Box, Typography, Alert, Button } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import DownloadIcon from '@mui/icons-material/Download'

interface ErrorStateProps {
  onRetry: () => void
  onDownload: () => void
  isRefreshing: boolean
  error?: string | null
}

export const ErrorState = ({ onRetry, onDownload, isRefreshing, error }: ErrorStateProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      p: 3,
      textAlign: 'center',
      minHeight: 200,
    }}
  >
    <Alert severity="error" sx={{ mb: 2, maxWidth: 400 }}>
      <Typography variant="body2">
        File access has expired. Please refresh to view the file.
      </Typography>
    </Alert>

    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
      <Button
        variant="contained"
        startIcon={<RefreshIcon />}
        onClick={onRetry}
        disabled={isRefreshing}
        size="small"
      >
        {isRefreshing ? 'Refreshing...' : 'Refresh'}
      </Button>

      <Button variant="outlined" startIcon={<DownloadIcon />} onClick={onDownload} size="small">
        Download
      </Button>
    </Box>

    {error && (
      <Typography variant="caption" color="error" sx={{ mt: 1 }}>
        {error}
      </Typography>
    )}
  </Box>
)
